import { Box, Chip, Step, StepLabel, Stepper } from "@mui/material";
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';
import CircleIcon from '@mui/icons-material/Circle';

const ColorLibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 11,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: theme.palette.primary.main
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.primary.main
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 1,
    border: 0,
    backgroundColor: theme.palette.primary.main,
    borderRadius: 1,
    ...theme.applyStyles('dark', {
      backgroundColor: 'white',
    })
  },
}));

function CustomStepIcon(props) {
    const { className, activeStep, icon } = props;

    return (
        <div className={className}>
            {
                icon === 1
                ?
                <Chip color="primary" label="Rate" sx={{p: 2}}/>
                :
                <CircleIcon 
                    sx={{
                        color: icon <= activeStep + 1 ? '#ea6142' : 'white',
                        backgroundColor: icon <= activeStep + 1 ? '#ea6142' : 'white',
                        border: `1px solid #ea6142`,
                        borderRadius: '50%',
                        width: '15px',
                        height: '15px'
                    }}
                />
            }
        </div>
    );
}

const CustomStepIconRoot = styled(CustomStepIcon)(({ theme, active }) => ({
    display: 'flex',
    height: 24,
    alignItems: 'center'
}));

const CalculatorStepper = ({
    step,
    stepList=[0,1,2,3,4]
}) => {
    return (
        <>
            <Box sx={{ width: '100%' }}>
                <Stepper 
                    activeStep={step} 
                    connector={<ColorLibConnector />}
                >
                    {
                        stepList.map((label) => (
                            <Step key={label}>
                                <StepLabel 
                                    slots={{
                                        stepIcon: CustomStepIconRoot,  
                                    }}
                                    slotProps={{
                                        stepIcon: {activeStep: step}
                                    }}
                                />
                            </Step>
                        ))
                    }
                </Stepper>
            </Box>
        </>
    );
}

export default CalculatorStepper;